<template>
  <div class="main">
    <Spinner class="is-size-3" v-if="isLoading" />

    <div class="notification is-danger" v-if="huntLoadError">{{ huntLoadError }}</div>

    <div class="container" v-if="hunt">
      <!-- Top card -->
      <div class="card">
        <!-- Top card header -->
        <header class="card-header">
          <div class="card-header-title">
            <div class="media">
              <div class="media-content">
                <p class="title is-4">{{ hunt.name }}</p>
              </div>
            </div>
          </div>
        </header>

        <!-- Top card content -->
        <div class="card-content hunt-area-info">
          <div class="content">
            <div class="table-container">
              <table class="table is-narrow">
                <tbody>
                  <tr>
                    <th class="is-narrow">
                      <span class="is-pulled-right">Id</span>
                    </th>
                    <td>
                      <span>{{ hunt.id }}_LLGroup</span>
                    </td>
                  </tr>
                  <tr>
                    <th class="is-narrow">
                      <span class="is-pulled-right">Created At</span>
                    </th>
                    <td>
                      <span>{{ hunt.createdAt }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th class="is-narrow">
                      <span class="is-pulled-right">Created By</span>
                    </th>
                    <td>
                      <span v-if="hunt.createdBy">
                        <span v-if="nameOfUserWithId(hunt.createdBy)">{{ nameOfUserWithId(hunt.createdBy) }} (<span>{{ hunt.createdBy }}_LLUser</span>)</span>
                        <span v-else>{{ hunt.createdBy }}_LLUser</span>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th class="is-narrow">
                      <span class="is-pulled-right">Status</span>
                    </th>
                    <td>
                      <span>{{ hunt.status }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th class="is-narrow">
                      <span class="is-pulled-right">Starts At</span>
                    </th>
                    <td>
                      <span>{{ hunt.startsAt }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th class="is-narrow">
                      <span class="is-pulled-right">Ends At</span>
                    </th>
                    <td>
                      <span>{{ hunt.endsAt }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Bottom tabs -->
      <div class="tabs is-toggle is-fullwidth bottom-tabs">
        <ul>
          <li v-for="tab in bottomTabs"
            :key="tab.index"
            :class="{'is-active': tab.index === selectedBottomTabIndex}"
            @click="selectBottomTab(tab)">

            <a>{{tab.name}}</a>
          </li>
        </ul>
      </div>

      <!-- Bottom tab content -->
      <div class="tabs-content">
        <component
          :is="selectedBottomTabComponent"
          :huntStorePath="huntStorePath" />
      </div>

    </div>
  </div>
</template>

<script>
import Spinner from "@/components/utils/Spinner";
import HuntMembersTab from "./HuntMembersTab";

import {
  LOAD_USERS_WITH_IDS,
  GET_USER_WITH_ID
} from "@/modules/users/usersCacheStore.js"

import {
  IS_LOADING_HUNT,
  GET_HUNT,
  GET_HUNT_LOAD_ERROR
} from "./huntStore.js"

export default {
  name: "Hunt",

  components: { Spinner },

  props: {
    huntStorePath: {
      type: String,
      required: true
    },

    usersCacheStorePath: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      bottomTabs: [
        {
          index: 0,
          name: "Members",
          component: HuntMembersTab
        }
      ],
      selectedBottomTabIndex: null
    };
  },

  methods: {
    selectBottomTab(tab) {
      this.selectedBottomTabIndex = tab.index;
    },

    nameOfUserWithId(userId) {
      if (!userId) {
        return null;
      }

      const getUserWithIdPath = `${this.usersCacheStorePath}/${GET_USER_WITH_ID}`;
      const user = this.$store.getters[getUserWithIdPath](userId);

      if (!user) {
        return null;
      }

      return `${user.firstName} ${user.lastName}`
    }
  },

  computed: {
    isLoading() {
      const isLoadingHuntPath = `${this.huntStorePath}/${IS_LOADING_HUNT}`;
      return this.$store.getters[isLoadingHuntPath];
    },

    hunt() {
      const getHuntPath = `${this.huntStorePath}/${GET_HUNT}`;
      return this.$store.getters[getHuntPath];
    },

    huntLoadError() {
      const getHuntLoadErrorPath = `${this.huntStorePath}/${GET_HUNT_LOAD_ERROR}`;
      return this.$store.getters[getHuntLoadErrorPath];
    },

    selectedBottomTabComponent() {
      if (this.selectedBottomTabIndex === null) {
        return null;
      }

      return this.bottomTabs[this.selectedBottomTabIndex].component;
    }
  },

  watch: {
    hunt() {
      if (!this.hunt) {
        return;
      }

      const loadUserWithIdsAction = `${this.usersCacheStorePath}/${LOAD_USERS_WITH_IDS}`;
      const userIds = [this.hunt.createdBy];
      this.$store.dispatch(loadUserWithIdsAction, { userIds });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/style.scss";

.main {
  overflow: auto;
  padding: 10px;
}

.hunt-area-info .table {
  th {
    padding-right: 0 !important;
    border-bottom: 0;

    span {
      font-weight: normal;
    }
  }

  td {
    border-bottom: 0;

    span {
      font-weight: bold;
      white-space: nowrap;
    }
  }
}

.bottom-tabs.tabs {
  margin-top: $column-gap * 2;

  a {
    padding: 4px 16px;
  }
}

.tabs-content {
  overflow: auto;
}
</style>
